import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { AppProviders } from '@/app/providers'
import { router } from '@/app/router'
import { applyStoredThemeSync } from '@/app/theme'

import './design/index.css'

// Prima del render, non dentro: se aspettasse un effect React, la pagina
// dipingerebbe un frame nel tema di default e poi scatterebbe in quello giusto.
applyStoredThemeSync()

const container = document.getElementById('root')
if (!container) {
  throw new Error('Elemento #root assente in index.html.')
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
